import { AUTH_SUCCESS, AUTH_LOGOUT, AUTH_TOKEN } from '../actions/constants/auth.constants';

const initialState = {
  token: null,
  user: null,
  permisos: null,
  configuracion: null,
};

export default function authReducer(state = initialState, { type = AUTH_SUCCESS, payload }) {
  switch (type) {
    case AUTH_SUCCESS: {
      const {
        token, user, permisos, configuracion,
      } = payload;
      return {
        ...state, token, user, permisos, configuracion,
      };
    }
    case AUTH_LOGOUT: {
      localStorage.clear();
      return initialState;
    }
    case AUTH_TOKEN: {
      const {
        token,
      } = payload;
      return {
        ...state, token,
      };
    }
    default:
      return state;
  }
}
